module.exports = __webpack_public_path__ + "img/portfolio.12e4f8a7.jpg";